const db = window.firebase.firestore();
export default db;



// WEBPACK FOOTER //
// ./src/firebaseAPI/index.js